
/* ============================== src/components/Avatar.jsx ============================== */
import { memo, useState, useRef, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import { initials } from "../utils/date";

/**
 * Аватар сотрудника с тултипом при наведении.
 */
const Avatar = memo(function Avatar({ employee, size = "sm", className = "" }) {
  const [tooltip, setTooltip] = useState({
    visible: false,
    text: "",
    x: 0,
    y: 0,
  });
  const ref = useRef(null);
  const tooltipRef = useRef(null);

  useLayoutEffect(() => {
    if (!tooltip.visible) return;
    const el = tooltipRef.current;
    if (!el) return;
    el.style.setProperty("--tooltip-x", `${tooltip.x}px`);
    el.style.setProperty("--tooltip-y", `${tooltip.y}px`);
  }, [tooltip.visible, tooltip.x, tooltip.y]);

  if (!employee) return null;

  const tooltipText = [
    `${employee.first} ${employee.last}`,
    employee.email ? `E-mail: ${employee.email}` : null,
    employee.extension ? `Вн. телефон: ${employee.extension}` : null,
  ]
    .filter(Boolean)
    .join("\n");

  const handleMouseEnter = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setTooltip({
        visible: true,
        text: tooltipText,
        x: rect.left + rect.width / 2,
        y: rect.top - 10,
      });
    }
  };

  const handleMouseLeave = () => {
    setTooltip((prev) => ({ ...prev, visible: false }));
  };

  const classes = `avatar${size ? " " + size : ""}${className ? " " + className : ""}`;

  const avatarContent = employee.photo ? (
    <img
      src={employee.photo}
      alt={`${employee.first} ${employee.last}`}
      className={`${classes} avatar-img`}
    />
  ) : (
    <div className={`${classes} avatar-initials`}>
      {initials(employee.first, employee.last) || "?"}
    </div>
  );

  return (
    <>
      <span
        ref={ref}
        className="avatar-wrapper"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {avatarContent}
      </span>

      {tooltip.visible &&
        createPortal(
          <div ref={tooltipRef} className="avatar-tooltip">
            {tooltip.text}
          </div>,
          document.body,
        )}
    </>
  );
});

export default Avatar;
